import styles from './intro.module.css'
import { ReactNode } from 'react'

export interface CrIntroProps {
  introText: ReactNode
  title: string
}
export const Intro = ({ introText, title }: CrIntroProps) => (
  <section>
    <h3 className={styles.heading}>{title}</h3>
    <div>{introText}</div>
  </section>
)
